import { Waves } from "lucide-react";
import { cn } from "@/lib/utils";

interface FlowLogoProps {
  size?: "sm" | "md" | "lg";
  className?: string;
  animate?: boolean;
  shape?: "squircle" | "circle";
}

const sizeClasses = {
  sm: "w-10 h-10",
  md: "w-14 h-14",
  lg: "w-24 h-24 md:w-32 md:h-32",
};

const iconSizes = {
  sm: "w-5 h-5",
  md: "w-7 h-7",
  lg: "w-12 h-12 md:w-16 md:h-16",
};

export default function FlowLogo({
  size = "md",
  className,
  animate = true,
  shape = "squircle",
}: FlowLogoProps) {
  const radius = shape === "circle" ? "rounded-full" : "rounded-2xl";
  const innerRadius = shape === "circle" ? "rounded-full" : "rounded-xl";

  return (
    <div className={cn("relative inline-flex", className)}>
      <div
        className={cn(
          sizeClasses[size],
          radius,
          "bg-gradient-to-br from-primary via-accent to-primary flex items-center justify-center shadow-lg hover:shadow-xl hover:scale-105 transition-all duration-300",
          animate && "animate-float",
        )}
      >
        <div className={cn("absolute inset-1 bg-gradient-to-br from-white/20 to-transparent", innerRadius)} />
        <Waves className={cn(iconSizes[size], "text-white drop-shadow-md relative z-10")} />
      </div>
    </div>
  );
}

